export default "/react/oohdesk-dsp-84a68103.svg";